/** The original user agent string before spoofing. */
export const originalUserAgent = navigator.userAgent;

/** A lowercase version of the original user agent string. */
const lowerCaseOriginalUserAgent = originalUserAgent.toLowerCase();

/** If the device is an iOS device. (iPhone, iPad, iPod, or Apple Vision) */
export const isIos =
    /iphone|ipad|ipod|applevision/.test(lowerCaseOriginalUserAgent) ||
    (lowerCaseOriginalUserAgent.includes('mac') && navigator.maxTouchPoints > 1);

/** If the browser is Safari (excluding Chrome, Chromium-based browsers, and Android browsers). */
export const isSafari =
    lowerCaseOriginalUserAgent.includes('safari') &&
    !lowerCaseOriginalUserAgent.includes('chrome') &&
    !lowerCaseOriginalUserAgent.includes('crios') &&
    !lowerCaseOriginalUserAgent.includes('android');

/** If the browser is Microsoft Edge. */
export const isEdge = /\bedg(?:e|a|ios)?\//.test(lowerCaseOriginalUserAgent);

const DOLBY_ATMOS_CODEC_TYPES = ['audio/mp4; codecs="ec-3"', 'audio/mp4; codecs="eac3"'];

function canDecodeDolbyAtmosCodec(): boolean {
    try {
        const mediaSource = (typeof window !== 'undefined' && window.MediaSource) || globalThis.MediaSource;
        if (mediaSource && typeof mediaSource.isTypeSupported === 'function') {
            if (DOLBY_ATMOS_CODEC_TYPES.some((type) => mediaSource.isTypeSupported(type))) {
                return true;
            }
        }

        if (typeof document !== 'undefined') {
            const audio = document.createElement('audio');
            return DOLBY_ATMOS_CODEC_TYPES.some((type) => !!audio.canPlayType(type));
        }
    } catch {
        // Codec probes can throw in privacy-hardened browsers.
    }

    return false;
}

export function canStreamDolbyAtmos(): boolean {
    return isIos || isSafari || isEdge || canDecodeDolbyAtmosCodec();
}
